import React from 'react'

function DownloadImage() {
  return (
    <div></div>
  )
}

export default DownloadImage